import { useEffect, useState } from 'react';

/**
 * Die Mobil-Grenze der App als einzige JavaScript-Quelle. `ui/` ist Leaf-Library — die
 * Zahl muss hier liegen, damit Bausteine sie lesen können, ohne aus `features/` zu
 * importieren.
 *
 * Grenze der App-Navbar ist eine ANDERE (768px, `components/Header.js`) — nicht vermischen.
 * Die Media-Queries im CSS tragen die 900 weiterhin selbst; eine Media-Query kann diese
 * Konstante nicht lesen.
 */
export const MOBILE_MAX_WIDTH_PX = 900;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;

export function useIsMobileViewport() {
  const [isMobile, setIsMobile] = useState(() => {
    // Guard, weil dieser Hook in jedem Baustein-Test läuft: Umgebungen ohne matchMedia
    // (jsdom-Setups) würden sonst beim Rendern werfen.
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  });
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    const anwenden = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', anwenden);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', anwenden);
  }, []);
  return isMobile;
}
